<report-grid-wrapper [header]="header" [accountId]="accountId" [type]="GridType.LIVE_EVENTS" [pollingIntervalSecs]="pollingIntervalSecs" [disableColumnPicker]="true">

	<vb-ui-infinite-scroll-grid [getRows]="EventAnalyticsService.getLiveEventRows" [pageSize]="pageSize" [defaultColumnSort]="{ colId: 'startDate', sort: 'desc' }" [fullWidthCellRendererFunc]="showMoreRecordsRowRenderer">

		<!--Default Columns-->
		<vb-ui-data-grid-column [field]="'startDate'" [headerName]="'Reports_Column_ScheduledStartDate' | translate" [valueFormatter]="mediumDateTimeValueFormatter" [filter]="false" [sortable]="false">
		</vb-ui-data-grid-column>

		<vb-ui-data-grid-column [field]="'title'" [headerName]="'Reports_Column_EventTitle' | translate" [tooltipField]="'title'" [filter]="true" [sortable]="false" cellRenderer="link" [cellRendererParams]="titleCellParams">
		</vb-ui-data-grid-column>

		<vb-ui-data-grid-column [field]="'status'" [headerName]="'Status' | translate" [valueFormatter]="statusValueFormatter" [sortable]="false" [filter]="false">
		</vb-ui-data-grid-column>

		<vb-ui-data-grid-column [field]="'attendeesCount'" [headerName]="'Reports_Column_Attendees' | translate" [sortable]="false" [filter]="false">
		</vb-ui-data-grid-column>

		<vb-ui-data-grid-column [field]="'rebufferingPerc'" [headerName]="'Reports_Column_ExperiencedRebuffering' | translate" [sortable]="false" [filter]="false">
		</vb-ui-data-grid-column>

		<vb-ui-data-grid-column [field]="'avgRebufferingDurationInSeconds'" [headerName]="'Reports_Column_AverageExperiencedRebufferDurationInSecs' | translate" [sortable]="false" [filter]="false">
		</vb-ui-data-grid-column>

		<vb-ui-data-grid-column [field]="'experiencedErrors'" [headerName]="'Reports_Column_ExperiencedErrorsByAttendees' | translate" [sortable]="false" [filter]="false">
		</vb-ui-data-grid-column>

	</vb-ui-infinite-scroll-grid>

</report-grid-wrapper>
